import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { addSubscriptionButtonChargeById, getSubscriptionButtonById, getSecretValuesById, BASE_URLS, getHealthCheck } from "../../api";
import { MESSAGES, SUBSCRIPTION_BUTTON_STATUSES, SWIREPAY_URL, TabNames, TANGEDCO_PG, LPG_CUSTOMER } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import * as moment from "moment-timezone";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import getformatteddate from "../../utils/getformatteddate";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import BankPayment from "../../components/bankpayment/BankPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import RecaptchaModal from "../../components/recaptcha";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
    history: {
        push: Function,
    },
}

const SubscriptionButton = (props: Props) => {
    const { match: { params: { subscriptionId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const disableButtonText = useState('The subscription is already started.');
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${subscriptionId}-tap-index`) || 0));
    const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
    const [currentDateFormattedString, setCurrentDateFormattedString] = useState();
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [tabName, setTabName] = useState('');
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const hostName = (window && window.location && window.location.host);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${subscriptionId}`) || undefined);
    const [ipAddress, setIpAddress] = useState('');
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
      }
    
      useEffect(() => {
        getData();
      }, []);


    useEffect(() => {
        if (search) {
            getSubscriptionButtonDataWithSearchValue();
        } else {
            getSubscriptionButtonDataWithoutSearchValue();
        }
    }, [subscriptionId, search]);

    useEffect(() => {
        if (payment && payment.currency && payment.planAmount) {
            setSubmitBtnText('Save Payment Method');
            setCurrentDateFormattedString(moment.utc().tz(payment && payment.account.timezone).startOf('day').utc().format(MOMENT_FORMAT));
        }
        if (payment && payment.account && payment.account.gid) {
            if (TANGEDCO_PG === payment.account.gid) {
                setSupportedPaymentTypes(['CARD']);
            } else if (TANGEDCO_PG !== payment.account.gid) {
                setSupportedPaymentTypes(payment && payment.account && payment.account.supportedRecurringPaymentTypes);
            }
        }

    }, [payment]);

    useEffect(() => {
        setTabName(supportedPaymentTypes && supportedPaymentTypes[selectedTab]);
    }, [selectedTab, supportedPaymentTypes]);

    useEffect(() => {
        if (payment && payment.currency && payment.currency.name !== 'INR') { setSelectedTab(0) }
    }, [selectedTab,]);

    const getSubscriptionButtonDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('ss') || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getSubscriptionButtonById(subscriptionId, search);
            if (value) {
                const { redirectUri, status } = value;
                if (SUBSCRIPTION_BUTTON_STATUSES.ACTIVE === status) {
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        if (redirectUri) {
                            window.location = `${redirectUri}?sp-subscription-button=${subscriptionId}`;
                        } else if (uri) {
                            window.location = `${uri}subscription-button/${subscriptionId}`;
                        }
                    }, 5000);
                }
            }
        } catch (reason) {
            try {
                const value = await getSubscriptionButtonById(subscriptionId, null);
                if (value) {
                    setPayment(value);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        if (!reason) return;
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support');
        }
    };

    const getSubscriptionButtonDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getSubscriptionButtonById(subscriptionId, null);
            if (value) {
                const { status, redirectUri } = value;
                if (SUBSCRIPTION_BUTTON_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                setBankImageUrl(value.account && value.account.bankImageUrl);
                setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                setBackButtonUrl(redirectUri || SWIREPAY_URL)
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
            ip: ipAddress,
            language: window.navigator.language, 
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height, 
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(), 
            browserUserAgent: window.navigator.userAgent
           };
        paymentMethod.userAgent = userAgent;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({ customerDetails: customer, paymentMethodDetails: paymentMethod });
    };

    const chargeByBank = async (data) => {
        const { customerGid, fundingSourceId } = data;
        const paymentMethod = {
            bank: {
                referenceId: fundingSourceId,
            },
            customerGid,
            type: "ACH"
        }
        await chargeById({ paymentMethod });
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await chargeById({ paymentMethod: paymentMethod });
    };

    const chargeById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const value = await addSubscriptionButtonChargeById(subscriptionId, data);
            if (value) {
                const { nextActionUrl, redirectUri } = value;
                if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                }
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    const uri = getRedirectionUrl(hostName);
                    if (redirectUri) {
                        window.location = `${redirectUri}?sp-subscription-button=${subscriptionId}`;
                    } else if (uri) {
                        window.location = `${uri}subscription-button/${subscriptionId}`;
                    }
                }, 5000);
                if (subscriptionId) { localStorage.removeItem(`${subscriptionId}-tap-index`) }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
        case TabNames.UPI:
            setPaymentLinkUpiGlobalRecaptcha(token);
            break;
        default:
            await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const uniquePaymentTypes = supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerEnabled={true}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                planStartDate={moment(payment && payment.planStartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={subscriptionId}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                showAddress={true}
                planStartDate={moment(payment && payment.planStartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
            />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                paymentLinkId={subscriptionId}
                iavUrl={`${BASE_URLS.SUBSCRIPTION_BUTTON}/${subscriptionId}`}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                disableButtonText={disableButtonText}
                customerValidation={true}
                showAddress={true}
                planStartDate={moment(payment && payment.planStartDate)}
                currentDateObject={moment(currentDateFormattedString)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
            />
        }
    ];

    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Add Payment Method
                        </H1Text>
                        <H2Text>
                            Payment For
                        </H2Text>
                        <DescriptionText>
                            {payment && payment.plan.name}
                        </DescriptionText>
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.total), payment.currency && payment.currency.name)}` : null}
                        </DescriptionText>
                        {
                            payment && payment.planStartDate && (
                                <>
                                    <H2Text>
                                        NEXT PLAN STARTS ON
                                    </H2Text>
                                    <DescriptionText>
                                        {getformatteddate(payment.planStartDate, (payment.account && payment.account.timezone))}
                                    </DescriptionText>
                                </>
                            )
                        }
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    bankImageUrl={bankImageUrl} 
                    cancelUrlLink={null}
                />
                <PaymentMethodTabs name={subscriptionId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={getMenuTabs(uniquePaymentTypes)}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    accountGid={payment?.account?.gid}
                />
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default SubscriptionButton;
